// Этот файл должен загружаться ПЕРВЫМ
import moment from 'moment';
import 'moment/locale/ru';

// Экспортируем в глобальную область
const globalObject = typeof window !== 'undefined' ? window : global;
globalObject.moment = moment;

// Для CommonJS окружения
if (typeof module !== 'undefined' && module.exports) {
    module.exports = moment;
}

export default moment;